import { useState, useCallback } from 'react';

// Mémorise le dernier format d'impression choisi (rouleau thermique ou A4).
const CLE = 'sv_format_impression';

export default function useFormatImpression() {
  const [format, setFormatState] = useState(() => {
    try { return localStorage.getItem(CLE) === 'a4' ? 'a4' : 'thermique'; }
    catch { return 'thermique'; }
  });
  const setFormat = useCallback((f) => {
    const v = f === 'a4' ? 'a4' : 'thermique';
    setFormatState(v);
    try { localStorage.setItem(CLE, v); } catch {}
  }, []);
  return [format, setFormat];
}
